import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { useGeneralStore } from "%/stores/general-store";

export const useUserPublicationFeedStore = defineSmartFeedPiniaStore(
  "user-publication-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      feedUrl: `/user/${useGeneralStore().userId}/publications`,
      defaultFilterValues: {
        orgId: {
          key: "org_id",
          payload: useGeneralStore().orgId,
        },
      },
    }),
  },
);
